import { Injectable } from "@angular/core";
import { Title, Meta } from "@angular/platform-browser";

@Injectable()
export class SiteSEOHelperService {
  constructor(private titleService: Title, private metaService: Meta) {}

  SetPageMetaData(
    metaTitle: string,
    metaDescription: string,
    metaKeywords: string
  ) {
    this.titleService.setTitle(metaTitle);
    this.metaService.updateTag({
      name: "description",
      content: metaDescription
    });
    this.metaService.updateTag({
      name: "keywords",
      content: metaKeywords
    });
  }
}
